// MyStoreTabs.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATH } from '../../constants/routePath';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faBagShopping, 
    faLink, 
    faMagicWandSparkles, 
    faStore 
} from '@fortawesome/free-solid-svg-icons';
import { 
    StyledTabs, 
    TabContent,
    TabIcon,
    TabLabel 
} from './styled';

const { TabPane } = StyledTabs;

const MyStoreTabs = ({ activeTab, onTabChange }) => {
    const navigate = useNavigate();

    const handleTabChange = (key) => {
        onTabChange(key);
        switch (key) {
            case 'store':
                navigate(ROUTE_PATH.MYSTORE);
                break;
            case 'shop':
                navigate(ROUTE_PATH.CREATOR_STORE);
                break;
            case 'design':
                navigate(ROUTE_PATH.DESIGN);
                break;
            case 'products':
                navigate(ROUTE_PATH.PRODUCTS);
                break;
            default:
                break;
        }
    };

    const tabs = [
        {
            key: 'design',
            icon: faMagicWandSparkles,
            label: 'Design',
        },
        {
            key: 'store',
            icon: faStore,
            label: 'My Page',
        },
        {
            key: 'shop',
            icon: faBagShopping,
            label: 'Shop',
        },
        {
            key: 'products',
            icon: faLink,
            label: 'Add Links',
        },
    ];

    return (
        <StyledTabs activeKey={activeTab} onChange={handleTabChange} centered>
            {tabs.map(({ key, icon, label }) => (
                <TabPane
                    key={key}
                    tab={
                        <TabContent isActive={activeTab === key}>
                            <TabIcon>
                                <FontAwesomeIcon icon={icon} />
                            </TabIcon>
                            <TabLabel>{label}</TabLabel>
                        </TabContent>
                    }
                />
            ))}
        </StyledTabs>
    );
};

export default MyStoreTabs;